<template>
  <div>
    <b-card :style="readOnly ? 'pointer-events: none; opacity: 0.65;' : ''">
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <projects-title-card />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <projects-description-card />
        </b-col>
        <b-col cols="12">
          <visibility-card
            store-module="projects"
            :disabled="!canChangeVisibility"
            :hint="$t('projects.form.visibilityHint')"
          />
        </b-col>
        <template v-if="!isPublic">
          <b-col cols="12">
            <manager-users-card
              store-module="projects"
              :disabled="!canChangeVisibility"
              :hint="$t('projects.form.managersHint')"
            />
          </b-col>
          <b-col cols="12">
            <watchers-card
              store-module="projects"
              :disabled="!canChangeVisibility"
              :hint="$t('projects.form.watchersHint')"
            />
          </b-col>
        </template>
        <b-col
          cols="12"
          md="4"
        >
          <projects-target-date-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <projects-departments-card />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <projects-teams-card />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import { canChangeProjectVisibility } from '@/auth/taskPermissions'
import VisibilityCard from '@/views/Tasks/Elements/VisibilityCard.vue'
import ManagerUsersCard from '@/views/Tasks/Elements/ManagerUsersCard.vue'
import WatchersCard from '@/views/Tasks/Elements/WatchersCard.vue'
import ProjectsTitleCard from '@/views/Projects/Elements/TitleCard.vue'
import ProjectsDescriptionCard from '@/views/Projects/Elements/DescriptionCard.vue'
import ProjectsTargetDateCard from '@/views/Projects/Elements/TargetDateCard.vue'
import ProjectsDepartmentsCard from '@/views/Projects/Elements/DepartmentsCard.vue'
import ProjectsTeamsCard from '@/views/Projects/Elements/TeamsCard.vue'

export default {
  name: 'ProjectsItemForm',
  components: {
    VisibilityCard,
    ManagerUsersCard,
    WatchersCard,
    ProjectsTitleCard,
    ProjectsDescriptionCard,
    ProjectsTargetDateCard,
    ProjectsDepartmentsCard,
    ProjectsTeamsCard,
    BCard,
    BRow,
    BCol,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['projects/dataItem']
    },
    isPublic() {
      return !!Number(this.itemData.is_public)
    },
    canChangeVisibility() {
      return !this.itemData.id || canChangeProjectVisibility(this.itemData)
    },
  },
}
</script>
